import { useEffect } from "react";

import { unqualifiedGiftLineIds } from "@/app/[tenant]/shop/promotion-messaging";

import { useShopCatalog } from "@/contexts/shop-catalog-provider";

import type { ShopCart } from "@/hooks/shop/use-shop-cart";

/** Drop free-gift lines the cart no longer qualifies for, once the catalog has loaded. */
export function useRemoveUnqualifiedGiftLines({
  lines,
  removeLine,
}: Pick<ShopCart, "lines" | "removeLine">) {
  const { catalog, isLoading, isError } = useShopCatalog();

  useEffect(() => {
    if (isLoading || isError) return;
    for (const lineId of unqualifiedGiftLineIds(catalog.promotions, lines)) {
      removeLine(lineId);
    }
  }, [catalog.promotions, isError, isLoading, lines, removeLine]);
}
